import {OnDestroy, Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import * as blobUtil from 'blob-util';

@Pipe({
  name: 'blob',
  pure: false
})
export class BlobPipe implements OnDestroy, PipeTransform {
  private cachedValue: string | Blob;

  private blobUrl: string;
  private url: SafeResourceUrl | string;

  constructor(private readonly sanitizer: DomSanitizer) {
  }

  ngOnDestroy() {
    if (this.blobUrl) {
      blobUtil.revokeObjectURL(this.blobUrl);
      this.blobUrl = null;
    }
  }

  transform(value: string | Blob): SafeResourceUrl | string {
    if (this.cachedValue !== value) {
      if (this.blobUrl) {
        blobUtil.revokeObjectURL(this.blobUrl);
        this.blobUrl = null;
      }

      this.cachedValue = value;

      if (value instanceof Blob) {
        this.blobUrl = blobUtil.createObjectURL(value);
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.blobUrl);
      } else {
        this.url = value;
      }
    }

    return this.url;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/blob.ts